import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { EmployeeRestPeriod, EmployeeRestPeriodModifyRequestBody } from '@/api/apis/resources';
import { resourcesQueryKeys } from '@/queries/resource/resources.keys';

const modifyEmployeeRestPeriodFactory = (
  request: (body: EmployeeRestPeriodModifyRequestBody) => Promise<EmployeeRestPeriod>,
) => {
  return () => {
    return useMutation({
      mutationFn: (body: EmployeeRestPeriodModifyRequestBody) => request(body),
      meta: {
        invalidates: [resourcesQueryKeys.getEmployeesReservations()],
      },
    });
  };
};

export const useModifyCSRestPeriodMutation = modifyEmployeeRestPeriodFactory(api.resource.modifyCSRestPeriod);
export const useModifyRSLiRestPeriodMutation = modifyEmployeeRestPeriodFactory(api.resource.modifyRSLiRestPeriod);
export const useModifyRSHtLuRestPeriodMutation = modifyEmployeeRestPeriodFactory(api.resource.modifyRSHtLuRestPeriod);
